<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import ReloadPickupBolCard from "@/views/trips/components/ReloadPickupBolCard.vue";
import type { Bol } from "@/api/trips/dto/trip.dto";

const { t } = useI18n();

withDefaults(
  defineProps<{
    bols: Bol[];
    allocatedBolIds?: string[];
  }>(),
  {
    allocatedBolIds: () => [],
  },
);
</script>

<template>
  <div class="d-flex flex-column row-gap-4">
    <div class="d-flex flex-column row-gap-2">
      <div class="font-size-16 font-weight-500 text-grey-navy">{{ t("trip.reload-bol-title") }}</div>
      <div v-if="bols.length" class="font-size-14 text-grey-darken-1" data-qa="reload-bol-subtitle">
        {{ t("trip.reload-bol-hint") }}
      </div>

      <div v-else class="bg-grey-lighten-3 border-grey-lighter-1 rounded-lg pa-4 d-flex align-center justify-center">
        {{ t("trip.reload-bol-empty") }}
      </div>
    </div>

    <reload-pickup-bol-card v-for="bol in bols" :key="bol.id" :allocated-bol-ids="allocatedBolIds" :bol="bol" />
  </div>
</template>
